import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import OrderManagementApiService from 'Service/OrderManagement/OrderManagementApiService';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setApprovalHistoryList } from 'Store/Component/ApprovalHistoryTab/ApprovalHistoryAction';
import { GET_APPROVAL_HISTORY_LIST } from 'Store/Component/ApprovalHistoryTab/ApprovalHistoryType';

function* getApprovalHistoryList(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Approval History ...."));

        let payloadData: IPayload = {
            apiMethod: apiMethod.GET,
            apiType: apiType.OrderManagement,
            endpoint: `orderapproval/order/approval/history/${req.orderRequestId}`,
            payload: null
        }

        const response = yield call(
            OrderManagementApiService.post,
            API_URL.PostWebApp, payloadData

        );

        if (response) {
            yield put(setApprovalHistoryList(response));
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        console.log(error);
        yield put(globalLoaderText(""));
        yield put(setApprovalHistoryList(null));
    }
}

function* watchApprovalHistory() {
    yield takeEvery(GET_APPROVAL_HISTORY_LIST, getApprovalHistoryList)
}

export default function* combinedSaga() {
    yield all([
        watchApprovalHistory()
    ])
}
